var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Trans, t } from '@lingui/macro';
import { Alert, DialogFooter, DialogHeader, Typography, useToast } from '@pocketlaw/tetris';
import { CancelButton, FormDialog, SubmitButton } from 'shared/domains/forms';
import { useDiscardFeedback } from './useDiscardFeedback';
import { StyledDialogContent } from './styled';
export function DiscardDialog(props) {
    const { onClose, feedbackId } = props;
    const { discardFeedback, error } = useDiscardFeedback();
    const { addToast } = useToast();
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        if (values.action === 'discard') {
            return discardFeedback(values).then(() => {
                onClose();
                addToast({
                    appearance: 'info',
                    title: t({
                        message: 'The issue has been discarded',
                        comment: 'Plai Review - Discard dialog - toast message - issue was discarded',
                    }),
                });
            });
        }
        return false;
    });
    const initialValues = { action: 'discard', feedbackId };
    return (<FormDialog onClose={onClose} initialValues={initialValues} onSubmit={handleSubmit}>
      <DialogHeader title={<Trans comment="Plai Review - Discard dialog - header title">Discard issue</Trans>}/>
      <StyledDialogContent>
        {error && <Alert appearance="danger" title="TODO: TECH-7637" message="Add error message"/>}
        <Typography>
          <Trans comment="Plai Review - Discard dialog - description">
            Do you want to discard this issue? This will remove the issue from the review process.
            You can reopen discarded issues at any time.
          </Trans>
        </Typography>
      </StyledDialogContent>
      <DialogFooter>
        <CancelButton onClick={onClose}>
          <Trans comment="Plai Review - Discard dialog - cancel button - label">Cancel</Trans>
        </CancelButton>
        <SubmitButton>
          <Trans comment="Plai Review - Discard dialog - submit button - label">Discard</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
